import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@/ui/tm-icon/tm-icons.types'
import ToIcon from '@/components/to-icon/to-icon.vue'

interface Props {
    name: Icon
    color?: string
    left?: boolean
    size?: string
    small?: boolean
}

interface ComponentConfiguration {
    component: 'v-icon' | typeof ToIcon
    name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'tm-icon',
  props: {
    name: null,
    color: { default: 'primary' },
    left: { type: Boolean, default: false },
    size: null,
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { name: Icon, color: string, left: boolean, size?: string, small?: boolean }



const vIconConfiguration = (name: string): ComponentConfiguration => ({ component: 'v-icon', name })
const toIconConfiguration = (name: string): ComponentConfiguration => ({ component: ToIcon, name })

const iconMap: Record<Icon, ComponentConfiguration> = {
    ai: vIconConfiguration('mdi-shimmer'),
    add: toIconConfiguration('add'),
    'arrow-right': toIconConfiguration('arrow-right'),
    bullseye: vIconConfiguration('mdi-bullseye'),
    close: vIconConfiguration('mdi-close'),
    calendar: vIconConfiguration('mdi-calendar'),
    edit: toIconConfiguration('edit'),
    'mdi-pencil': vIconConfiguration('mdi-pencil'),
    'mdi-pencil-off': vIconConfiguration('mdi-pencil-off'),
    'mdi-lock': vIconConfiguration('mdi-lock'),
    delete: vIconConfiguration('mdi-delete'),
    'thumbs-up': toIconConfiguration('thumbs-up'),
    'thumbs-down': toIconConfiguration('thumbs-down'),
    'use-case': vIconConfiguration('mdi-lightbulb-on-outline'),
    upvote: vIconConfiguration('mdi-chevron-up'),
    downvote: vIconConfiguration('mdi-chevron-down'),
    challenges: toIconConfiguration('challenges'),
    opportunities: toIconConfiguration('opportunities'),
    flames: toIconConfiguration('flames'),
    'information-outline': vIconConfiguration('mdi-information-outline'),
    shimmer: vIconConfiguration('mdi-shimmer'),
    export: toIconConfiguration('export'),
    'closed-lock': vIconConfiguration('mdi-lock'),
    globe: vIconConfiguration('mdi-earth'),
    bell: vIconConfiguration(' mdi-bell')
}

const component = () => iconMap[props.name].component
const iconName = () => iconMap[props.name].name

return { __sfc: true,props, vIconConfiguration, toIconConfiguration, iconMap, component, iconName }
}

})